var React = require('react');

function PostRTriangleMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M143.34 136.704L97.4984 4.29882M143.34 136.704L78.149 84.8613M143.34 136.704L14.4996 80.0689M97.4984 4.29882L78.149 84.8613M97.4984 4.29882L14.4996 80.0689M78.149 84.8613L14.4996 80.0689","stroke":"#DADADA"}));
}

PostRTriangleMobile.defaultProps = {"width":"137","height":"164","viewBox":"0 0 137 164","fill":"none"};

module.exports = PostRTriangleMobile;

PostRTriangleMobile.default = PostRTriangleMobile;
